import { api } from 'api'
import { Roster, User, Work, WorkShift } from 'typings/common_defs'
import { path } from 'ramda'

export enum WorkStatusEnum {
  Scheduled = 'scheduled',
  Started = 'started',
  Approved = 'approved',
  EmployerApproved = 'employer_approved',
  Removed = 'removed',
  ReservationCancelled = 'reservation_cancelled',
  Offered = 'offered',
  AdminReview = 'admin_review',
  Completed = 'completed',
  WorkerDeclinedRequest = 'worker_declined_req',
  Bailed = 'bailed',
  EmployerReview = 'employer_review',
  Rejected = 'rejected',
  Reserved = 'reserved',
  ReservationExpired = 'reservation_expired',
  EmployerCancelled = 'employer_cancelled',
  SystemDeclinedRequest = 'system_declined_req',
  Paid = 'paid',
}

export const LegacyDeclinedWorkStatuses = [
  WorkStatusEnum.WorkerDeclinedRequest,
  WorkStatusEnum.SystemDeclinedRequest,
  WorkStatusEnum.Rejected,
]

export const DeclinedWorkStatuses = [
  WorkStatusEnum.WorkerDeclinedRequest,
  WorkStatusEnum.Rejected,
]

export const CompletedWorkStatuses = [
  WorkStatusEnum.Completed,
  WorkStatusEnum.Paid,
  WorkStatusEnum.EmployerReview,
  WorkStatusEnum.EmployerApproved,
  WorkStatusEnum.AdminReview,
  WorkStatusEnum.Approved,
]

interface TimelineShiftRoster extends Omit<Roster, 'workers'> {
  workers?: Array<Pick<User, 'id' | 'name' | 'profilePicUrl'>>
}

export interface TimelineShift
  extends Omit<
    WorkShift,
    'startsAt' | 'endsAt' | 'work' | 'rosters' | 'workersNeeded'
  > {
  startsAt: string
  endsAt: string
  work?: Array<Omit<Work, 'status'> & { status?: WorkStatusEnum }>
  rosters?: Array<TimelineShiftRoster>
  workersNeeded: number | null
  hideBonus?: boolean
}

interface ShiftTimelineOptions {
  startAt?: Date
  locationId?: number
  positionId?: number
  headCursor?: string
  tailCursor?: string
}

export interface PaginatedShiftTimeline {
  items: TimelineShift[]
  headCursor?: string
  tailCursor?: string
}

export async function getShiftsForTimeline(options: ShiftTimelineOptions) {
  const { startAt, locationId, positionId, headCursor, tailCursor } = options

  const result = await api.post(
    '/company/graphql_dispatch/shifts_for_timeline_a024cfed',
    {
      startDate:
        startAt && !(headCursor || tailCursor)
          ? startAt.toISOString()
          : undefined,
      headCursor,
      tailCursor,
      positionId,
      locationId,
    }
  )

  const data = path(
    ['data', 'data', 'company', 'infiniteShifts'],
    result
  ) as PaginatedShiftTimeline | null

  return data ?? { items: [] }
}

export async function getTimelineShift(id: number) {
  const data = await api.post(
    '/company/graphql_dispatch/timeline_shift_8ec3f2cb',
    {
      id,
    }
  )

  return path(
    ['data', 'data', 'company', 'shiftsDetail', 0],
    data
  ) as TimelineShift
}
